<template>
  <div>
    <div class="cus-panel-heading">
      <h4 class="cus-panel-title">{{ $t('customer.partialRefundInvoiceTitle') }}</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
          @branch-edit="branchEdit"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>

          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.partial_refund_id"
              >
                <!-- <td>{{ r.branch_name }}</td> -->
                <td>{{ r.theOrderID }}</td>
                <td>{{ r.amount }}</td>
                <td>{{ r.note }}</td>
                <td>{{ r.created_at }}</td>
                <!-- <td>
                  <div class="d-flex">
                    <a
                      :tooltip="$t('invoice.invoiceTooltip')"
                      class="px-1"
                      @click="viewRecord(r.partial_refund_id)"
                    >
                      <i
                        class="fa fa-file-text-o"
                        style="font-size: 18px; color: #666"
                      ></i>
                    </a>
                  </div>
                </td> -->
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    {{ $t('common.noResultsFound') }}
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <mobile-datatable
            v-if="isMobile"
            :isOrder="true"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.order_invoice_id"
              >
                <td>
                  <!-- Branch: {{ r.branch_name }} , <br /> -->
                  {{ $t('addEditOrderCase.orderIdColon') }} {{ r.theOrderID }}
                </td>
                <td>
                  {{ $t('columns.amount') }}: {{ r.amount }} , <br />
                  {{ $t('columns.note') }}: {{ r.note }} , <br />
                  {{ $t('columns.createdAt') }}: {{ r.created_at }}
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  colspan="2"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    {{ $t('common.noResultsFound') }}
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </mobile-datatable>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <view-order-invoice
      :viewOrderInvoiceModal="viewOrderInvoiceModal"
      :invoiceData="invoiceData"
      :companyData="companyData"
      @close="viewOrderInvoiceModal = false"
    /> -->
  </div>
</template>

<script>
import PaginationVue from '../Pagination.vue'
import preDatatableComponent from '../preDatatableComponent.vue'
import DatatableVue from '../Datatable.vue'
import axios from 'axios'
import swal from 'sweetalert'
import mobileDatatable from '../mobileDatatable'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'mobile-datatable': mobileDatatable
  },
  created() {
    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  mounted() {
    this.perPageFix()
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      // {
      //   label: 'Branch',
      //   text: 'Branch',
      //   value: '1',
      //   sortable: true,
      //   searchable: false,
      //   name: 'branch_name'
      // },
      {
        label: this.$t('columns.caseOrderId'),
        text: this.$t('columns.caseOrderId'),
        value: '1',
        sortable: true,
        searchable: true,
        name: 'theOrderID'
      },
      {
        label: this.$t('columns.amount'),
        text: this.$t('columns.amount'),
        value: '2',
        sortable: true,
        searchable: true,
        name: 'amount'
      },
      {
        label: this.$t('columns.note'),
        text: this.$t('columns.note'),
        value: '3',
        sortable: true,
        searchable: true,
        name: 'note'
      },
      {
        label: this.$t('columns.createdAt'),
        text: this.$t('columns.createdAt'),
        value: '4',
        sortable: true,
        searchable: true,
        name: 'created_at'
      }
    ]
    columns.forEach((column) => {
      sortOrders[column.name] = -1
    })

    return {
      url: 'api/customer/partial-refund',
      alertValue: false,
      btnsave: true,
      viewOrderInvoiceModal: false,
      invoiceData: {
        customer: {},
        orders: []
      },
      companyData: {},
      filterMade: false,
      totalResult: 0,
      prevSearchQuery: '',
      apiResults: [],
      columns: columns,
      sortKey: 'partial_refund_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    // Scoped to #datatable (this page's own <datatable> table) and deterministic set/unset —
    // the old unscoped $('td:nth-child(N)') selector matched EVERY table on the page, including
    // the Generate/View Invoice modal's items-table (also 7 columns), silently hiding its Total
    // cell whenever this page's own column visibility got applied. See orderInvoices.vue's
    // showHideColumn for the same fix.
    showHideColumn(prevColVal, currentColVal) {
      const hidden = {}
      currentColVal.forEach((v) => { hidden[v] = true })

      for (let i = 1; i <= this.columns.length; i++) {
        const selector = '#datatable td:nth-child(' + i + '),#datatable th:nth-child(' + i + ')'
        if (hidden[i]) {
          $(selector).hide()
        } else {
          $(selector).show()
        }
      }
    },

    getCompanyData(token) {
      axios
        .get('api/company_info', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.companyData = response.data.data
        })
    },

    viewRecord(id) {
      let token = localStorage.getItem('access_token')
      this.getCompanyData(token)

      axios
        .get(`api/order_invoice/${id}`, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((res) => {
          this.viewOrderInvoiceModal = true
          this.invoiceData = res.data
        })
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          const isFlatArray = Array.isArray(data.data)
          if (isFlatArray) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (isFlatArray) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch((errors) => { })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    resetGetResults2() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: this.$t('common.typeToSearch'),
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

.has-error .select2-selection--single:not([class*='bg-']):not([class*='border-']) {
  border-bottom-color: red;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}
</style>



// WEBPACK FOOTER //
// src/components/customer/customerPartialRefundInvoices.vue